


import React from "react";
import PickMeals from "../Assets/pick-meals-image.png";
import ChooseMeals from "../Assets/choose-image.png";
import DeliveryMeals from "../Assets/delivery-image.png";

const Work = () => {
  const workInfoData = [
    {
      image: PickMeals,
      title: "Pick Meals",
      text: "Where we bring you the perfect blend of classic comfort food and delicious new twists. Whether you're craving a hearty meal, a light snack, or something sweet to finish your meal, we have something for everyone. Explore our menu and enjoy the flavors that will keep you coming back for more!",
    },
    {
      image: ChooseMeals,
      title: "Choose How Often",
      text: "We know that everyone has their own dining rhythm, whether you’re treating yourself once in a while or enjoying our meals regularly. With our “Choose How Often” feature, you can personalize your dining experience to fit your schedule! ",
    },
    {
      image: DeliveryMeals,
      title: "Fast Deliveries",
      text: "Craving a delicious meal but don’t want to wait? With our Fast Deliveries feature, your favorite dishes are on their way to you in no time!Hungry? Don’t wait. Order now and enjoy the fastest delivery with Foodie!",
    },
  ];
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Work</p>
        <h1 className="primary-heading">How It Works</h1>
        <p className="primary-text">
        Browse our diverse menu, view detailed descriptions of each dish, and customize your order according to your preferences. You can choose from our appetizers, mains, desserts, and drinks, with options for special dietary needs.
        </p>
        
      </div>
      <div className="work-section-bottom">
        {workInfoData.map((data) => (
          <div className="work-section-info" key={data.title}>
            <div className="info-boxes-img-container">
              <img src={data.image} alt="" />
            </div>
            <h2>{data.title}</h2>
            <p>{data.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Work;